import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { useDocs } from '../hooks/use-docs.hook'
import { DocInterface } from '../interfaces/doc.interface'

export function DocContainer() {
  const navigate = useNavigate()
  const docsHook = useDocs()
  return (
    <Layout
      pageTitle="Central de ajuda"
      handleGoBack={() => navigate('/documentacao')}
    >
      <DocInterface {...docsHook} />
    </Layout>
  )
}
